const CONTENT_PATH_PATTERN = /^\/(materials|academy|catalog)\/[a-z0-9]+(?:-[a-z0-9]+)*$/;

const assertContentPath = (path) => {
  if (!CONTENT_PATH_PATTERN.test(path)) {
    throw new Error(`Некорректный публичный путь: ${path}`);
  }
};

export const requestSsgPublication = async (api, path) => {
  assertContentPath(path);
  const { data } = await api.request({
    path: "/dashboard/ssg-rebuild",
    method: "POST",
    secure: true,
    type: "application/json",
    format: "json",
    body: {
      reason: "admin:publication-confirmation",
      paths: [path],
    },
  });
  return data;
};

export const getSsgPublicationStatus = async (api, path, requestedAt) => {
  assertContentPath(path);
  const { data } = await api.request({
    path: "/dashboard/ssg-rebuild/status",
    method: "GET",
    secure: true,
    format: "json",
    query: { path, requestedAt },
  });
  return data;
};

export const publicationStatusText = (state) => {
  switch (state) {
    case "saving":
      return "Контент сохраняется";
    case "queued":
      return "Контент сохранён. Страница ожидает сборки";
    case "building":
      return "SSG собирает и проверяет публичную страницу";
    case "ready":
      return "Страница опубликована: прямая ссылка и sitemap проверены";
    case "worker_unavailable":
      return "Контент сохранён, но SSG-worker пока недоступен";
    case "failed":
      return "Контент сохранён, но публикация не подтверждена";
    default:
      return "Ожидание подтверждения публикации";
  }
};
